import { FormFieldModel } from '@/core/models/onboarding'
import i18n from '../i18n'

export const labelWithRequiredCheck = (model: FormFieldModel) => {
  const label = i18n.t(model.label)
  return model.validation?.required ? `${label} *` : label
}
